import React, { useState, useEffect } from 'react';

interface ToastProps {
  message: string;
  type: 'success' | 'error';
  onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({ message, type, onClose }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (message) {
      setVisible(true);

      const timer = setTimeout(() => {
        setVisible(false);
        setTimeout(onClose, 300); // espera a animação terminar
      }, type === 'success' ? 3000 : 5000);

      return () => clearTimeout(timer);
    }
  }, [message, onClose, type]);

  if (!message) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        padding: '12px 20px',
        borderRadius: 5,
        color: type === 'success' ? '#065f46' : '#fff',
        backgroundColor: type === 'success' ? '#D1FAE5' : '#ce6565ff',
        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
        zIndex: 9999,
        minWidth: 200,
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(-20px)',
        transition: 'opacity 0.3s ease, transform 0.3s ease',
      }}
      role="alert"
      aria-live="assertive"
    >
      {message}
    </div>
  );
};

export default Toast;
